<template>
  <div class="default">
    <img src="https://imgcdn.chuxingyouhui.com/blackunique/upload/cae0b76bab79035a9037f71b347099c5.png">
    <div class="desc">
      {{ resultInfo.prizeDescription }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'Default',
  props: {
    resultInfo: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../scale.scss';
.default {
  display: flex;
  flex-direction: column;
  width: 630px * $scale;
  img {
    width: 100%;
    object-fit: cover;
  }
  .desc {
    margin-top: 41px * $scale;
    margin-bottom: 26px * $scale;
    font-size: 28px * $scale;
    font-weight: 500;
    color: #333333;
    line-height: 44px * $scale;
  }
}
</style>
